import { BRAND } from "@/brand";

/**
 * OPLYX Logo — usa os arquivos PNG oficiais da marca.
 *
 * Props:
 *   size     — altura em px (default 24)
 *   wordmark — boolean: true = oplyx-small-*, false = oplyx-icon-512-* (default true)
 *   className — classes do wrapper
 *   tone     — "dark"     : fundo escuro → usa -transparent.png (elementos brancos, bg transparente)
 *              "light"    : DEPRECATED — equivale a "dark" (evita retângulo branco)
 *              "auto"     : fundo escuro → usa -transparent.png (mesmo que "dark")
 *              "adaptive" : troca com dark mode do Tailwind
 *                           (-white no light mode: tinta escura em fundo branco;
 *                            -transparent no dark mode: tinta branca)
 *
 * REGRA: fundos claros/creme → use <img src="/oplyx-small-cream.png"> diretamente.
 *        Não existe tone para fundo claro — os arquivos -cream.png têm bg opaco embutido.
 */
export function OplyxLogo({ size = 24, wordmark = true, className = "", tone = "auto" }) {
  const base = wordmark ? "oplyx-small" : "oplyx-icon-512";
  const dims = wordmark
    ? { height: size, style: { objectFit: "contain", width: "auto" } }
    : { width: size, height: size, style: { objectFit: "contain" } };

  if (tone === "adaptive") {
    return (
      <span
        className={`inline-flex items-center ${className}`}
        data-brand="oplyx"
        aria-label={BRAND.name}
      >
        {/* Tema claro: tinta escura sobre branco (-white). Tema escuro: tinta
            branca sobre transparente (-transparent). Estava invertido — no claro
            as letras e a parte branca do símbolo sumiam. */}
        <img src={`/${base}-white.png`} alt={BRAND.name} {...dims} className="dark:hidden" />
        <img src={`/${base}-transparent.png`} alt="" aria-hidden="true" {...dims} className="hidden dark:block" />
      </span>
    );
  }

  // Todos os tones não-adaptive usam a variante transparent (elementos brancos, bg transparente)
  // — correta para fundos escuros. Fundos claros devem usar os arquivos -cream.png diretamente.
  return (
    <span
      className={`inline-flex items-center ${className}`}
      data-brand="oplyx"
      aria-label={BRAND.name}
    >
      <img src={`/${base}-transparent.png`} alt={BRAND.name} {...dims} />
    </span>
  );
}

export function Symbol({ size = 24 }) {
  return (
    <img
      src="/oplyx-icon-512-transparent.png"
      alt="OPLYX"
      width={size}
      height={size}
      style={{ objectFit: "contain" }}
    />
  );
}

export default OplyxLogo;
